import { render, staticRenderFns } from "./BayFullHatchCovers.vue?vue&type=template&id=97d1cc2a&scoped=true"
import script from "./BayFullHatchCovers.vue?vue&type=script&lang=js"
export * from "./BayFullHatchCovers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d1cc2a",
  null
  
)

export default component.exports